import { Location, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import {  GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';


@Component({
  selector: 'app-customer-plan',
  standalone: true,
  imports: [CommonModule, TimezoneDatePipe],
  templateUrl: './customer-plan.component.html',
  styleUrls: ['./customer-plan.component.scss','../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class CustomerPlanComponent implements OnInit {

 
  userPlanArr : Array<any> = [];
  userPlanDetails: any;
  BID: string;
  role:any
  MemberShipType :any
  


   // Given plan based return the boolean value ttrue and false based on i will show in plan table
   checkUserPlan(): boolean { 
    return (
      this.MemberShipType === GigsumoConstants.StarterPlan ||
      this.MemberShipType === GigsumoConstants.GrowthPlan ||
      this.MemberShipType === GigsumoConstants.ScaleXPlan
    );
  }

 
  

  GigsumoConstants=GigsumoConstants; 
  constructor(
    private API :ApiService, 
    private aroute : ActivatedRoute,
    private util: UtilService,
      private location: Location,

  ) {

    this.aroute.parent.data.subscribe(res=>{
      this.BID = res.data.id;
      this.role= res.data.role;
      this.MemberShipType = res.data.plan;
    });

   }

  ngOnInit(): void {
    //If business super admin is the business plan we called getBUsinessPLanBenefits() function by monisha
    if(this.role === 'SUPERADMIN' && [GigsumoConstants.StarterPlan , GigsumoConstants.GrowthPlan ,GigsumoConstants.ScaleXPlan].includes(this.MemberShipType)){
      this.getBUsinessPLanBenefits();
    }else{
      //otherwise called Free Plan  getUserPlansandBenefits() function by monisha
      this.getUserPlansandBenefits();
    }

  }
  async getUserPlansandBenefits(){
    this.util.startLoader();
    const userPlan: any = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));
    this.util.stopLoader();
    this.userPlanArr = userPlan.data.userPlanAndBenefits.benefitsUsages;
    this.userPlanDetails = userPlan.data.userPlanAndBenefits;
  }
  async getBUsinessPLanBenefits(){
    this.util.startLoader();
    const userPlan : any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.BID);
    this.util.stopLoader();
    this.userPlanArr = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    this.userPlanDetails = userPlan.data.businessPlanAndBenefits;
  }

  getTotal(key: BENEFITS_KEY) {
    if (this.userPlanArr && this.userPlanArr.length > 0) {
      const foundItem = this.userPlanArr.find(c => c.benefitKey === key);
      if(['INCLUDED_CONVERSATIONS','PERSONAL_NETWORKS','B2B_CONTACTS','B2B_NETWORKS','JOBS_CANDIDATE_ACTIVE_CREATIONS'].includes(key)){
        // return foundItem ? (foundItem.actual == 99999999 ? 'Unlimited' : foundItem.actual) : null;
        return 'Unlimited';
      }
      return foundItem ? foundItem.actual : null;
    }
    return null;
  }
  getTopup(key: BENEFITS_KEY) {
    if (this.userPlanArr && this.userPlanArr.length > 0) {
      const foundItem = this.userPlanArr.find(c => c.benefitKey === key);
      return foundItem ? foundItem.payAsyouGo : null;
    }
    return null;
  }
  getAllocated(key: BENEFITS_KEY) {
    if (this.userPlanArr && this.userPlanArr.length > 0) {
      const foundItem = this.userPlanArr.find(c => c.benefitKey === key);
      return foundItem ? foundItem.utilized : null;
    }
    return null;
  }

  getAvailable(key: BENEFITS_KEY) {
    if (this.userPlanArr && this.userPlanArr.length > 0) {
      const foundItem = this.userPlanArr.find(c => c.benefitKey === key);
      if(['INCLUDED_CONVERSATIONS','PERSONAL_NETWORKS','B2B_CONTACTS','B2B_NETWORKS','JOBS_CANDIDATE_ACTIVE_CREATIONS'].includes(key)){
        // return foundItem ? (foundItem.actual == 99999999 ? 'Unlimited' : foundItem.available) : null;
        return 'Unlimited';
      }
      return foundItem ? foundItem.available : null;
    }
    return null;
  }
  getpromotional(key: BENEFITS_KEY) {
    if (this.userPlanArr && this.userPlanArr.length > 0) {
      const foundItem = this.userPlanArr.find(c => c.benefitKey === key);
      return foundItem ? foundItem.promotional : null;
    }
    return null;
  }

  get effectiveFromDate(): Date | null {
    return this.userPlanDetails?.billingType === 'MONTH' || this.userPlanDetails?.billingType === null
      ? this.userPlanDetails?.fromDate
      : this.userPlanDetails?.planStartDate;
  }

  get effectiveToDate(): Date | null {
    return this.userPlanDetails?.billingType === 'MONTH' || this.userPlanDetails?.billingType === null
      ? this.userPlanDetails?.toDate
      : this.userPlanDetails?.planEndDate;
  }


}
